import React from 'react';
import {
	Datagrid,
	List,
	TextField,
	DateField,
	SelectField,
	SelectInput,
	EditButton,
	Filter, TopToolbar, ExportButton,
} from 'react-admin';

import { statuses, typeUser, CLIENT_BACKGROUND_COLOR } from './constants';
import ResponseButton from './components/ResponseButton';
import UserProfileField from '../../components/UserProfileField';

const feedbackStatusesChoices = [
	{ id: statuses.unread, name: 'нет' },
	{ id: statuses.read, name: 'да' },
];

const typeUserFilterChoices = [
	{ id: typeUser.Client, name: 'Пользователь' },
	{ id: typeUser.Admin, name: 'Администратор' },
];

const ListFeedbackActions = ({ basePath, data }) => (
	<TopToolbar>
		<ExportButton basePath={basePath} record={data} />
	</TopToolbar>
);

const FeedbackFilter = (props) => (
	<Filter {...props}>
		<SelectInput
			label="Прочитано"
			source="status"
			choices={feedbackStatusesChoices}
			alwaysOn
			parse={(v) => (v === '' ? undefined : { $eq: v })}
			format={({ $eq }) => ($eq || '')}
		/>
		<SelectInput
			label="Тип автора"
			source="typeUser"
			choices={typeUserFilterChoices}
			alwaysOn
			parse={(v) => (v === '' ? undefined : { $eq: v })}
			format={({ $eq }) => ($eq || '')}
		/>
	</Filter>
);

const feedbackRowStyle = (record) => ({
	backgroundColor: record?.typeUser === typeUser.Client ? CLIENT_BACKGROUND_COLOR : 'white',
});

export default (props) => (
	<List
		{...props}
		actions={<ListFeedbackActions />}
		title="Feedback"
		sort={{ field: 'createdAt', order: 'DESC' }}
		filters={<FeedbackFilter />}
		filterDefaultValues={{
			status: statuses.unread,
			typeUser: typeUser.Client,
		}}
	>
		<Datagrid rowClick="show" rowStyle={feedbackRowStyle}>
			<UserProfileField label="Пользователь" source="user.id" />
			<TextField label="Сообщение" source="message" />
			<DateField label="Создано" source="createdAt" showTime />
			<SelectField label="Прочитано" source="status" choices={feedbackStatusesChoices} />
			<ResponseButton />
			<EditButton />
		</Datagrid>
	</List>
);

